import 'vue';
import { merge } from './helpers.mjs';
import { setVueInstance, setOptions, Programmatic, getOptions } from './config.mjs';
export { Plugin as Config, Programmatic as ConfigProgrammatic } from './config.mjs';
import { r as registerPlugin, a as registerComponentProgrammatic } from './plugins-ba5e2464.mjs';
export { u as useProgrammatic } from './plugins-ba5e2464.mjs';
export { s as OIcon } from './Icon-a7b85e86.mjs';
import './FormElementMixin-29581863.mjs';
export { s as OInput } from './Input-19e906a1.mjs';
export { s as OAutocomplete } from './Autocomplete-a23ad844.mjs';
import index from './autocomplete.mjs';
export { default as Autocomplete } from './autocomplete.mjs';
export { s as OButton } from './Button-c75f7992.mjs';
import index$1 from './button.mjs';
export { default as Button } from './button.mjs';
import './InjectedChildMixin-5282461d.mjs';
import index$2 from './carousel.mjs';
export { default as Carousel, OCarousel, OCarouselItem } from './carousel.mjs';
import './CheckRadioMixin-f5b57344.mjs';
export { s as OCheckbox } from './Checkbox-8670724c.mjs';
import index$3 from './checkbox.mjs';
export { default as Checkbox } from './checkbox.mjs';
import index$4 from './collapse.mjs';
export { default as Collapse, OCollapse } from './collapse.mjs';
import './MatchMediaMixin-09b141ca.mjs';
import './trapFocus-dc03669f.mjs';
export { s as ODropdown, a as ODropdownItem } from './DropdownItem-c744c4e9.mjs';
export { s as OField } from './Field-937b4591.mjs';
export { s as OSelect } from './Select-be742134.mjs';
export { s as ODatepicker } from './Datepicker-fd29656a.mjs';
import index$5 from './datepicker.mjs';
export { default as Datepicker } from './datepicker.mjs';
export { s as OTimepicker } from './Timepicker-499884b4.mjs';
import index$6 from './datetimepicker.mjs';
export { default as Datetimepicker, ODatetimepicker } from './datetimepicker.mjs';
import index$7 from './dropdown.mjs';
export { default as Dropdown } from './dropdown.mjs';
import index$8 from './field.mjs';
export { default as Field } from './field.mjs';
import index$9 from './icon.mjs';
export { default as Icon } from './icon.mjs';
import index$a from './input.mjs';
export { default as Input } from './input.mjs';
import index$b from './inputitems.mjs';
export { default as Inputitems, OInputitems } from './inputitems.mjs';
import './ssr-85c76d50.mjs';
export { s as OLoading } from './Loading-20d29914.mjs';
import './InstanceRegistry-2fdb6ee8.mjs';
import index$c from './loading.mjs';
export { default as Loading, LoadingProgrammatic } from './loading.mjs';
import index$d from './menu.mjs';
export { default as Menu, OMenu, OMenuItem, OMenuList } from './menu.mjs';
import index$e from './modal.mjs';
export { default as Modal, ModalProgrammatic, OModal } from './modal.mjs';
import index$f from './notification.mjs';
export { default as Notification, NotificationProgrammatic, ONotification } from './notification.mjs';
export { s as OPagination, a as OPaginationButton } from './Pagination-92dc61c2.mjs';
import index$g from './pagination.mjs';
export { default as Pagination } from './pagination.mjs';
import index$h from './radio.mjs';
export { ORadio, default as Radio } from './radio.mjs';
import index$i from './select.mjs';
export { default as Select } from './select.mjs';
import index$j from './skeleton.mjs';
export { OSkeleton, default as Skeleton } from './skeleton.mjs';
import index$k from './sidebar.mjs';
export { OSidebar, default as Sidebar } from './sidebar.mjs';
export { s as OTooltip } from './Tooltip-7e114fbb.mjs';
import index$l from './slider.mjs';
export { OSlider, OSliderTick, default as Slider } from './slider.mjs';
import './SlotComponent-11a269f3.mjs';
import './TabbedChildMixin-a08c8659.mjs';
import index$m from './steps.mjs';
export { OStepItem, OSteps, default as Steps } from './steps.mjs';
import index$n from './switch.mjs';
export { OSwitch, default as Switch } from './switch.mjs';
import index$o from './table.mjs';
export { OTable, OTableColumn, default as Table } from './table.mjs';
import index$p from './tabs.mjs';
export { OTabItem, OTabs, default as Tabs } from './tabs.mjs';
import index$q from './timepicker.mjs';
export { default as Timepicker } from './timepicker.mjs';
import index$r from './tooltip.mjs';
export { default as Tooltip } from './tooltip.mjs';
import index$s from './upload.mjs';
export { OUpload, default as Upload } from './upload.mjs';

var plugins = /*#__PURE__*/Object.freeze({
    __proto__: null,
    Autocomplete: index,
    Button: index$1,
    Carousel: index$2,
    Checkbox: index$3,
    Collapse: index$4,
    Datepicker: index$5,
    Datetimepicker: index$6,
    Dropdown: index$7,
    Field: index$8,
    Icon: index$9,
    Input: index$a,
    Inputitems: index$b,
    Loading: index$c,
    Menu: index$d,
    Modal: index$e,
    Notification: index$f,
    Pagination: index$g,
    Radio: index$h,
    Select: index$i,
    Skeleton: index$j,
    Sidebar: index$k,
    Slider: index$l,
    Steps: index$m,
    Switch: index$n,
    Table: index$o,
    Tabs: index$p,
    Timepicker: index$q,
    Tooltip: index$r,
    Upload: index$s
});

const Oruga = {
    install(app, options = {}) {
        setVueInstance(app);
        // Options
        const defaultConfig = getOptions();
        setOptions(merge(defaultConfig, options, true));
        // Components
        for (const componentKey in plugins) {
            registerPlugin(app, plugins[componentKey]);
        }
        // Config component
        registerComponentProgrammatic(app, 'config', Programmatic);
    }
};

export default Oruga;
